<div class="date-range-picker-container">
  <div class="dp-hidden position-absolute">
    <div class="input-group">
      <input name="datepicker"
             class="form-control"
             ngbDatepicker
             #datepicker="ngbDatepicker"
             [autoClose]="'outside'"
             (dateSelect)="onDateSelection($event)"
             [displayMonths]="2"
             [dayTemplate]="t"
             outsideDays="hidden"
             [startDate]="startDate!"
             tabindex="-1" />
      <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
  <div class="input-group">
    <input #dpFromDate
           class="form-control"
           placeholder="yyyy-mm-dd"
           name="dpFromDate"
           readonly
           [(ngModel)]="selectedDateRange"
           (input)="startDate = validateInput(startDate, dpFromDate.value)" />
    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datepicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
  </div>
</div>

